import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

const DEFAULT_PHONE_DDI = "55";

const getDigitsOnly = (value: string): string => value.replace(/\D/g, "");

const getNationalPhoneDigits = (
  value: string,
  defaultDDI = DEFAULT_PHONE_DDI
): string => {
  const digits = getDigitsOnly(value);
  const ddiDigits = getDigitsOnly(defaultDDI);

  if (digits.startsWith(ddiDigits)) {
    return digits.slice(ddiDigits.length);
  }

  return digits;
};

export function normalizePartnerPhone(
  raw: string,
  defaultDDI = DEFAULT_PHONE_DDI
): string {
  const trimmedPhone = raw.trim();

  if (!trimmedPhone) {
    return raw;
  }

  const digits = getDigitsOnly(trimmedPhone);
  const ddiDigits = getDigitsOnly(defaultDDI);

  if (!digits) {
    return raw;
  }

  if (digits.startsWith(ddiDigits)) {
    return digits;
  }

  return `${ddiDigits}${digits}`;
}

export function formatPhone(phone?: string): string {
  if (!phone) return "-";

  const nationalDigits = getNationalPhoneDigits(phone);

  if (nationalDigits.startsWith("0800") && nationalDigits.length >= 10) {
    return `${nationalDigits.slice(0, 4)} ${nationalDigits.slice(
      4,
      7
    )} ${nationalDigits.slice(7)}`;
  }

  if (nationalDigits.length === 11) {
    return `+55 (${nationalDigits.slice(0, 2)}) ${nationalDigits.slice(
      2,
      7
    )}-${nationalDigits.slice(7)}`;
  }

  if (nationalDigits.length === 10) {
    return `+55 (${nationalDigits.slice(0, 2)}) ${nationalDigits.slice(
      2,
      6
    )}-${nationalDigits.slice(6)}`;
  }

  return phone;
}

export function formatDuration(totalMinutes: number): string {
  const d = dayjs.duration(totalMinutes, "minutes");

  const days = Math.floor(d.asDays());
  const hours = d.hours();
  const minutes = d.minutes();
  const seconds = d.seconds();

  let result = "";
  if (days > 0) result += `${days}d `;
  if (hours > 0) result += `${hours}h `;
  if (minutes > 0) result += `${minutes}m `;
  if (seconds > 0) result += `${seconds}s`;

  return result.trim();
}

export function formatCPF(cpf?: string): string {
  if (!cpf) return "";

  const digits = getDigitsOnly(cpf);

  if (digits.length !== 11) {
    return cpf;
  }

  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(
    6,
    9
  )}-${digits.slice(9)}`;
}
